import { Component, OnInit, Input } from '@angular/core'
import { ICabinGroup } from 'app/cabins/cabins.interfaces'
import { FormGroup } from '@angular/forms'
import moment from 'moment'

@Component({
    selector: 'sbw-cabins-category-group',
    templateUrl: './cabins-category-group.component.html',
    styleUrls: ['./cabins-category-group.component.css']
})
export class CabinsCategoryGroupComponent implements OnInit {

    @Input() cabinGroup: ICabinGroup
    @Input() departureDate: string;
    @Input() formSelections: FormGroup;

    constructor() { }

    ngOnInit() {
    }

    public formattedDate(date) {
        return moment(date).format('dddd DD/MM - HH:mm')
    }
}
